document.addEventListener('DOMContentLoaded', () => {
const menuToggle = document.querySelector('.menu-toggle');
const navigation = document.querySelector('.nav-links');
const header = document.querySelector('.header');
const navLinks = [...document.querySelectorAll('.nav-links a')];
const productRail = document.querySelector('#productRail');
const productCards = [...document.querySelectorAll('.product-card')];
const categoryButtons = [...document.querySelectorAll('.category')];
const cartCount = document.querySelector('.cart b');
const toast = document.querySelector('#toast');
const toastMessage = toast ? toast.querySelector('span') : null;
let cartItems = 0;
let toastTimer;

function setMenu(open) {
  menuToggle.classList.toggle('active', open);
  navigation.classList.toggle('open', open);
  document.body.classList.toggle('menu-open', open);
  menuToggle.setAttribute('aria-expanded', String(open));
  menuToggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
}

if (!menuToggle || !navigation) return;
menuToggle.addEventListener('click', () => setMenu(!navigation.classList.contains('open')));
navLinks.forEach((link) => link.addEventListener('click', () => setMenu(false)));
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') setMenu(false);
});

document.querySelectorAll('a[href^="#"]').forEach((link) => {
  link.addEventListener('click', (event) => {

    const href = link.getAttribute('href');

    // Ignore empty hashes like href="#"
    if (!href || href === '#') {
      return;
    }

    let target;

    try {
      target = document.querySelector(href);
    } catch (e) {
      return;
    }

    if (!target) return;

    event.preventDefault();

    setMenu(false);

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    history.replaceState(null, '', href);
  });
});

window.addEventListener('scroll', () => {
  header.classList.toggle('stuck', window.scrollY > 120);
});

const observedSections = [...document.querySelectorAll('header[id], main section[id]')];
const sectionObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    navLinks.forEach((link) => link.classList.toggle('active', link.getAttribute('href') === `#${entry.target.id}`));
  });
}, { rootMargin: '-35% 0px -60% 0px' });
observedSections.forEach((section) => sectionObserver.observe(section));

function scrollProducts(direction) {
  const firstVisible = productRail.querySelector('.product-card:not(.hidden)');
  if (!firstVisible) return;
  const amount = firstVisible.getBoundingClientRect().width + 24;
  productRail.scrollBy({ left: direction * amount, behavior: 'smooth' });
}

const prevProductButton = document.querySelector('#prevProduct');
const nextProductButton = document.querySelector('#nextProduct');
if (prevProductButton && nextProductButton) {
prevProductButton.addEventListener('click', () => scrollProducts(-1));
nextProductButton.addEventListener('click', () => scrollProducts(1));
}

categoryButtons.forEach((button) => {
  button.addEventListener('click', () => {
    categoryButtons.forEach((item) => item.classList.remove('active'));
    button.classList.add('active');
    productCards.forEach((card) => {
      const visible = button.dataset.category === 'all' || button.dataset.category === card.dataset.kind;
      card.classList.toggle('hidden', !visible);
    });
    productRail.scrollTo({ left: 0, behavior: 'smooth' });
  });
});

const recipeSlides = [
  {
    title: 'Hara Bhara Chicken',
    wheelTitle: 'Hara Bhara <br>Chicken',
    bowlImage: window.bowlImages.chickenVeg,
    copy: 'Approx. energy: 130 kcal per 100 g meal. Values should be lab-verified before final packaging use.',
    ingredients: [
      ['Whole Chicken', '36 g', '84', '#ffd0c2'],
      ['Chicken Liver', '5 g', '8', '#efb0a4'],
      ['Chicken Heart', '7 g', '13', '#f4b8a9'],
      ['Chicken Gizzard', '3 g', '3', '#f1c0b4'],
      ['Pumpkin', '20 g', '5', '#ffc875'],
      ['Peas', '5 g', '4', '#d8e999'],
      ['Carrot', '15 g', '6', '#ffb17c'],
      ['Sweet Potato', '6 g', '5', '#f1c68e'],
      ['Flax Seeds', '1.3 g', '7', '#d5aa73'],
      ['Ashwagandha', '0.1 g', '~0', '#c5d2a1'],
      ['Turmeric', '0.2 g', '~1', '#f0cf58'],
      ['Chia Seeds', '1.4 g', '7', '#d6d3c8']
    ]
  },
  {
    title: 'Chicken Chawal',
    wheelTitle: 'Chicken <br>Chawal',
    bowlImage: window.bowlImages.chickenRice,
    copy: 'Approx. energy: 135 kcal per 100 g meal. Values should be lab-verified before final packaging use.',
    ingredients: [
      ['Whole Chicken', '35 g', '84', '#ffd0c2'],
      ['Chicken Liver', '6 g', '10', '#efb0a4'],
      ['Chicken Heart', '7 g', '13', '#f4b8a9'],
      ['Pumpkin', '5 g', '1', '#ffc875'],
      ['Rice', '8.7 g', '11', '#fff1c7'],
      ['Peas', '5 g', '4', '#d8e999'],
      ['Carrot', '10 g', '4', '#ffb17c'],
      ['Sweet Potato', '6 g', '5', '#f1c68e'],
      ['Flax Seeds', '2 g', '11', '#d5aa73'],
      ['Ashwagandha', '0.1 g', '~0', '#c5d2a1'],
      ['Turmeric', '0.2 g', '~1', '#f0cf58'],
      ['Water', '15 g', '0', '#dcecff']
    ]
  },
  {
    title: 'Shahi Paneer Bowl',
    wheelTitle: 'Shahi Paneer<br>Bowl',
    bowlImage: window.bowlImages.paneer,
    copy: 'Approx. energy: 153 kcal per 100 g meal. Values should be lab-verified before final packaging use.',
    ingredients: [
      ['Paneer', '28 g', '74', '#fff0bf'],
      ['Rice', '11 g', '14', '#fff1c7'],
      ['Yellow Dal', '8 g', '9', '#f0cf58'],
      ['Water', '22 g', '0', '#dcecff'],
      ['Carrot', '9 g', '4', '#ffb17c'],
      ['Green Peas', '3 g', '2', '#d8e999'],
      ['Pumpkin', '11 g', '3', '#ffc875'],
      ['Spinach', '7 g', '2', '#cde192'],
      ['Chia Seeds', '1 g', '5', '#d6d3c8']
    ]
  },
  {
    title: 'Anda Curry Bowl',
    wheelTitle: 'Anda Curry <br>Bowl',
    bowlImage: window.bowlImages.egg,
    copy: 'Approx. energy: 119 kcal per 100 g meal. Values should be lab-verified before final packaging use.',
    ingredients: [
      ['Egg', '48 g', '69', '#fff7df'],
      ['Quinoa', '13 g', '16', '#f2d999'],
      ['Sweet Potato', '7 g', '6', '#f1c68e'],
      ['Carrot', '8 g', '3', '#ffb17c'],
      ['Pumpkin', '3.5 g', '1', '#ffc875'],
      ['Spinach', '3 g', '1', '#cde192'],
      ['Green Peas', '3 g', '2', '#d8e999'],
      ['Zucchini', '3 g', '<1', '#c6dda7'],
      ['Pumpkin Seed Powder', '2 g', '11', '#c6b77e'],
      ['Chia Seeds', '1 g', '5', '#d6d3c8'],
      ['Turmeric', '1 g', '3', '#f0cf58'],
      ['Ashwagandha', '0.5 g', '1', '#c5d2a1'],
      ['Eggshell Calcium', '1 g', '0', '#f0eee7'],
      ['Green Beans', '3 g', '1', '#bfe0a2'],
      ['Water', '3 g', '0', '#dcecff']
    ]
  }
];

const recipeTitle = document.querySelector('#ingredientRecipeTitle');
const recipeCopy = document.querySelector('#ingredientRecipeCopy');
const recipeCount = document.querySelector('#recipeCount');
const wheelRecipeName = document.querySelector('#wheelRecipeName');
const ingredientWheel = document.querySelector('#ingredientWheel');
const ingredientButtons = document.querySelector('#ingredientButtons');
const ingredientBenefits = document.querySelector('#ingredientBenefits');
const ingredientMeta = document.querySelector('#ingredientMeta');
const recipeDots = document.querySelector('#recipeDots');
let activeRecipe = 0;

const ingredientBenefitCopy = {
  'Whole Chicken': ['Complete animal protein source', 'Supports muscle maintenance and daily vitality'],
  'Chicken Liver': ['Provides iron, copper, and vitamin A', 'Adds natural flavor in controlled quantity'],
  'Chicken Heart': ['Source of taurine and CoQ10', 'Supports normal cardiovascular and muscle function'],
  'Chicken Gizzard': ['Provides protein, zinc, and selenium', 'Adds natural texture diversity'],
  Pumpkin: ['Soluble fiber source', 'Supports digestive regularity and stool quality'],
  Carrot: ['Beta-carotene rich vegetable', 'Supports micronutrient density and normal eye health'],
  'Sweet Potato': ['Complex carbohydrate and fiber source', 'Supports steady energy and digestive comfort'],
  'Flax Seeds': ['Source of ALA omega-3 fatty acids', 'Supports skin, coat, and digestive wellness'],
  Ashwagandha: ['Functional herb in controlled quantity', 'Supports stress response, vitality, and immune balance'],
  Turmeric: ['Curcumin-containing ingredient', 'Supports antioxidant activity and joint comfort'],
  'Chia Seeds': ['Omega-3 and soluble fiber source', 'Supports digestion, hydration, and skin-coat health'],
  Rice: ['Gentle carbohydrate source', 'Supports digestible energy and soft meal binding'],
  Peas: ['Adds plant protein and B vitamins', 'Supports micronutrient diversity'],
  'Green Peas': ['Adds plant protein and B vitamins', 'Supports vegetable diversity'],
  Water: ['Supports moisture balance and cooking', 'Helps create a soft wet food texture'],
  Paneer: ['Palatable dairy protein source', 'Contributes calcium, phosphorus, energy, and texture'],
  'Yellow Dal': ['Plant-based protein source', 'Adds B vitamins, minerals, and fiber'],
  Spinach: ['Provides iron, folate, and magnesium', 'Adds antioxidant phytonutrients'],
  Egg: ['Highly digestible complete protein', 'Supports muscle maintenance and palatability'],
  Quinoa: ['Digestible pseudo-cereal', 'Provides plant protein, minerals, and dietary fiber'],
  Zucchini: ['Moisture-rich vegetable', 'Adds gentle fiber contribution'],
  'Pumpkin Seed Powder': ['Provides beneficial fats and zinc', 'Adds magnesium and plant-based protein'],
  'Eggshell Calcium': ['Natural calcium source', 'Supports bone, teeth, and mineral balance'],
  'Green Beans': ['Low-calorie fiber source', 'Supports digestive regularity and vegetable diversity']
};
const ingredientIcons = window.BuddyCareIngredientIcons || {};

function showIngredientBenefit(ingredientIndex) {
  const [name, quantity, calories, color] = recipeSlides[activeRecipe].ingredients[ingredientIndex];
  ingredientButtons.querySelectorAll('.ingredient-button').forEach((button, index) => button.classList.toggle('active', index === ingredientIndex));
  ingredientBenefits.querySelector('small').textContent = 'SEE WHY WE USE IT';
  ingredientBenefits.querySelector('h3').textContent = name;
  ingredientMeta.textContent = `${quantity} per 100 g meal · approx. ${calories} kcal contribution`;
  const benefitItems = ingredientBenefits.querySelectorAll('li');
  const benefits = ingredientBenefitCopy[name] || ['Measured whole-food ingredient', 'Part of the balanced formulation'];
  benefitItems[0].textContent = benefits[0];
  benefitItems[1].textContent = benefits[1];
  ingredientBenefits.style.setProperty('--benefit-color', color);
}

function renderRecipe(recipeIndex) {
  activeRecipe = (recipeIndex + recipeSlides.length) % recipeSlides.length;
  const recipe = recipeSlides[activeRecipe];
  ingredientWheel.classList.add('changing');
  setTimeout(() => {
    recipeTitle.textContent = recipe.title;
    recipeCopy.textContent = recipe.copy;
    recipeCount.textContent = `${String(activeRecipe + 1).padStart(2, '0')} / ${String(recipeSlides.length).padStart(2, '0')}`;
    wheelRecipeName.innerHTML = recipe.wheelTitle;
    const bowlImage = document.getElementById('recipeBowlImage');

if (bowlImage) {
    bowlImage.src = recipe.bowlImage;
    bowlImage.alt = recipe.title;
}
    ingredientWheel.setAttribute('aria-label', `Ingredients in ${recipe.title}`);
    let outerCount;

if (window.innerWidth <= 576) {

    outerCount = Math.min(10, recipe.ingredients.length);

} else {

    outerCount = Math.ceil(recipe.ingredients.length / 2);

}
    ingredientButtons.innerHTML = recipe.ingredients.map(([name, quantity, , color], index) => {
      const outerRing = index < outerCount;
      const ringIndex = outerRing ? index : index - outerCount;
      const ringCount = outerRing ? outerCount : recipe.ingredients.length - outerCount;
      const angleOffset = outerRing ? -90 : -90 + (180 / Math.max(ringCount, 1));
      const angle = angleOffset + (ringIndex * 360 / ringCount);
      let outerRadius = -205;
let innerRadius = -135;

if (window.innerWidth <= 576) {

    outerRadius = -132;
    innerRadius = -82;

} else if (window.innerWidth <= 991) {

    outerRadius = -175;
    innerRadius = -112;

}

const icon = ingredientIcons[name] || '';

return `<button
  type="button"
  class="ingredient-button"
  data-ring="${outerRing ? 'outer' : 'inner'}"
  style="
    --ingredient-color:${color};
    --angle:${angle}deg;
    --inverse-angle:${-angle}deg;
    --radius:${outerRing ? outerRadius : innerRadius}px"
  data-ingredient-index="${index}"
  aria-label="Show formulation details for ${name}">
  
  <img
    src="${icon}"
    alt=""
    aria-hidden="true"
  >

</button>`;

    }).join('');
    ingredientButtons.querySelectorAll('.ingredient-button').forEach((button) => button.addEventListener('click', () => showIngredientBenefit(Number(button.dataset.ingredientIndex))));
    recipeDots.querySelectorAll('.recipe-dot').forEach((dot, index) => dot.classList.toggle('active', index === activeRecipe));
    showIngredientBenefit(0);
    ingredientWheel.classList.remove('changing');
  }, 170);
}

if (recipeDots && ingredientWheel && ingredientButtons) {
recipeSlides.forEach((recipe, index) => {
  const dot = document.createElement('button');
  dot.type = 'button';
  dot.className = 'recipe-dot';
  dot.setAttribute('aria-label', `Show ${recipe.title}`);
  dot.addEventListener('click', () => renderRecipe(index));
  recipeDots.appendChild(dot);
});
const prevRecipe = document.querySelector('#prevRecipe');
const nextRecipe = document.querySelector('#nextRecipe');

if (prevRecipe) {
  prevRecipe.addEventListener('click', () => renderRecipe(activeRecipe - 1));
}

if (nextRecipe) {
  nextRecipe.addEventListener('click', () => renderRecipe(activeRecipe + 1));
}
renderRecipe(0);
}

const reviews = [
  ['Stories from pet parents who brought home the goodness of home.', 'BC', "Buddy's Care", 'Review prompt: what did your dog enjoy most?', '4.9'],
  ["How did Buddy's Care make feeding easier for you?", 'PP', 'Pet Parent Prompt', 'Collecting real family experiences', '4.9'],
  ["Which product became your dog's favourite bowl?", 'FB', 'Favourite Bowl Prompt', 'Chicken, vegetarian, egg, and treats', '4.8'],
  ["Would you recommend Buddy's Care to another busy pet parent?", 'RC', 'Recommendation Prompt', "Real experiences from Buddy's Care families", '4.9']
];
const reviewQuote = document.querySelector('#reviewQuote');
const reviewInitials = document.querySelector('#reviewInitials');
const reviewName = document.querySelector('#reviewName');
const reviewMeta = document.querySelector('#reviewMeta');
const reviewScore = document.querySelector('#reviewScore');
const reviewDots = document.querySelector('#reviewDots');
const reviewSlide = document.querySelector('#reviewSlide');
let activeReview = 0;

function renderReview(reviewIndex) {
  activeReview = (reviewIndex + reviews.length) % reviews.length;
  const [quote, initials, name, meta, score] = reviews[activeReview];
  reviewSlide.classList.add('changing');
  setTimeout(() => {
    reviewQuote.textContent = quote;
    reviewInitials.textContent = initials;
    reviewName.textContent = name;
    reviewMeta.textContent = meta;
    reviewScore.textContent = score;
    reviewDots.querySelectorAll('.review-dot').forEach((dot, index) => dot.classList.toggle('active', index === activeReview));
    reviewSlide.classList.remove('changing');
  }, 140);
}

if (reviewDots && reviewSlide) {
reviews.forEach((review, index) => {
  const dot = document.createElement('button');
  dot.type = 'button';
  dot.className = 'review-dot';
  dot.setAttribute('aria-label', `Show review ${index + 1}`);
  dot.addEventListener('click', () => renderReview(index));
  reviewDots.appendChild(dot);
});
const prevReview = document.querySelector('#prevReview');
const nextReview = document.querySelector('#nextReview');

if (prevReview) {
  prevReview.addEventListener('click', () => renderReview(activeReview - 1));
}

if (nextReview) {
  nextReview.addEventListener('click', () => renderReview(activeReview + 1));
}
renderReview(0);
}

function showToast(message) {
  if (!toast || !toastMessage) return;
  clearTimeout(toastTimer);
  toastMessage.textContent = message;
  toast.classList.add('show');
  toastTimer = setTimeout(() => toast.classList.remove('show'), 2300);
}


const newsletter = document.querySelector('#newsletter');
const formStatus = document.querySelector('#formStatus');
if (newsletter && formStatus) newsletter.addEventListener('submit', (event) => {
  event.preventDefault();
  const email = newsletter.querySelector('input').value.trim();
  formStatus.textContent = `The Goodness of Home updates will go to ${email}.`;
  newsletter.reset();
});
});

// Real-Time Cart Updates with "Debounce" (Speed Boost)
  let cartUpdateTimer; 

  document.addEventListener('click', async (e) => {
    
    // --- NEW UPSELL ADD LOGIC ---
    if (e.target.classList.contains('bc-upsell-add')) {
      e.preventDefault();
      const btn = e.target;
      const variantId = btn.dataset.id;

      btn.textContent = 'Adding...';
      btn.style.pointerEvents = 'none';

      try {
        // 1. Add item to Shopify database
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        
        // 2. Refresh cart HTML
        const res = await fetch(window.location.pathname + '?section_id=main-cart');
        const text = await res.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const newCart = html.querySelector('.bc-container');
        if(newCart) document.querySelector('.bc-container').innerHTML = newCart.innerHTML;
        
        // 3. Update header cart count
        const cartReq = await fetch('/cart.js');
        const cartData = await cartReq.json();
        const cartBadge = document.querySelector('.round-button.cart b');
        if (cartBadge) cartBadge.textContent = cartData.item_count;
        
      } catch(err) {
        console.error('Error adding upsell item', err);
        btn.textContent = 'Add to Bowl';
        btn.style.pointerEvents = 'auto';
      }
    }
    
    // --- EXISTING QUANTITY (+/-) LOGIC ---
    const isQtyButton =
  e.target.classList.contains('qty-btn') ||
  e.target.classList.contains('bc-qty-btn');

if (isQtyButton) {
      e.preventDefault();
      
      const btn = e.target;
      const isPlus =
  btn.classList.contains('plus') ||
  btn.classList.contains('bc-qty-plus');
const wrapper = btn.closest('.bc-quantity');

if (!wrapper) return;

const input = wrapper.querySelector('input');

if (!input) return;
      const key = input.dataset.key;
      
      let val = parseInt(input.value) || 0;
      let newVal = isPlus ? val + 1 : (val > 0 ? val - 1 : 0);
      
      if (val !== newVal) {
        input.value = newVal;
        wrapper.style.opacity = '0.6'; 
        clearTimeout(cartUpdateTimer);
        
        cartUpdateTimer = setTimeout(async () => {
          wrapper.style.pointerEvents = 'none';
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: newVal })
            });
            const res = await fetch(window.location.pathname + '?section_id=main-cart');
            const text = await res.text();
            const html = new DOMParser().parseFromString(text, 'text/html');
            const newCart = html.querySelector('.bc-container');
            if(newCart) document.querySelector('.bc-container').innerHTML = newCart.innerHTML;
            
            const cartReq = await fetch('/cart.js');
            const cartData = await cartReq.json();
            const cartBadge = document.querySelector('.round-button.cart b');
            if (cartBadge) cartBadge.textContent = cartData.item_count;
          } catch (err) {
            console.error('Error updating cart', err);
            wrapper.style.opacity = '1';
            wrapper.style.pointerEvents = 'auto';
          }
        }, 400); 
      }
    }
  });


  document.documentElement.classList.remove('no-js');

const revealItems = document.querySelectorAll('.bc-reveal');
if ('IntersectionObserver' in window) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) entry.target.classList.add('is-visible');
    });
  }, { threshold: 0.16 });
  revealItems.forEach((item) => revealObserver.observe(item));
} else {
  revealItems.forEach((item) => item.classList.add('is-visible'));
}

document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const nav = document.querySelector(button.dataset.menuToggle);
    if (!nav) return;
    const isOpen = nav.classList.toggle('is-open');
    document.body.classList.toggle('menu-open', isOpen);
    button.setAttribute('aria-expanded', String(isOpen));
  });
});

const parallaxArt = document.querySelectorAll('[data-bc-parallax]');
window.addEventListener('mousemove', (event) => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const x = (event.clientX / window.innerWidth - 0.5) * 16;
  const y = (event.clientY / window.innerHeight - 0.5) * 12;
  parallaxArt.forEach((item) => {
    item.style.setProperty('--mx', `${x}px`);
    item.style.setProperty('--my', `${y}px`);
  });
});

document.querySelectorAll('[data-faq-exclusive]').forEach((group) => {
  group.querySelectorAll('details').forEach((detail) => {
    detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      group.querySelectorAll('details').forEach((other) => {
        if (other !== detail) other.removeAttribute('open');
      });
    });
  });
});
document.querySelectorAll(".bc-recommendations").forEach((section) => {
    const track = section.querySelector("[data-slider-track]");
    const prev = section.querySelector("[data-slider-prev]");
    const next = section.querySelector("[data-slider-next]");

    if (!track || !prev || !next) return;

    const scrollAmount = 300;

    prev.addEventListener("click", () => {
        track.scrollBy({
            left: -scrollAmount,
            behavior: "smooth"
        });
    });

    next.addEventListener("click", () => {
        track.scrollBy({
            left: scrollAmount,
            behavior: "smooth"
        });
    });
});